/**
 * 订阅按钮
 * 
 * @Author: Focci
 * @Date: 2023-08-04 13:59:20
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-04 13:59:20
 */

'use client'

import PropTypes from 'prop-types'
import useDialog from '@hook/useDialog'
import useLogin from '@hook/useLogin'
import SVGAddSubcribe from '@img/add-subcribe.svg'
import SVGAddedSubcribe from '@img/added-subcribe.svg'
import { useCallback, useState } from 'react'
import { useTranslations } from 'next-intl'
import { ButtonBase } from '@comp/material'
import { checkSubcribe } from './lib'
import SubcribeContent from './SubcribeContent'

function FilterDefaultTrigger({
  onClick = () => {},
  isSubcribed
}) {
  const ts = useTranslations('search')
  const tl = useTranslations('live')

  return (
    <ButtonBase onClick={() => !isSubcribed && onClick()}>
      <div className="flex items-center gap-1 border border-c3b rounded-[.2rem] h-8 px-3">
        {isSubcribed ? <SVGAddedSubcribe width=".8rem" /> : <SVGAddSubcribe width=".8rem" />}
        <span className="whitespace-nowrap">
          {isSubcribed ? tl('subscribed') : ts('subcribeFilter')}
        </span>
      </div>
    </ButtonBase>
  )
}

export default function SubcribeTrigger({
  type = '',
  searchParam = {},
  Trigger = FilterDefaultTrigger
}) {
  const ts = useTranslations('search')
  
  const { openDialog, closeDialog, Dialog } = useDialog()
  const { isLogin, openSigninDialog } = useLogin()
  const [isSubcribed, setIsSubcribed] = useState(false)

  const handleOpenDialog = useCallback(() => {
    if(!isLogin) {
      return openSigninDialog()
    }
    return openDialog()
  }, [isLogin, openDialog, openSigninDialog])

  const handleSuccess = useCallback(() => {
    closeDialog()
    setIsSubcribed(true)
  }, [closeDialog])
  
  if(!checkSubcribe(type)) {
    return null
  }
  
  return (
    <>
      <Trigger 
        isSubcribed={isSubcribed}
        onClick={handleOpenDialog}
      />
      <Dialog title={ts('subcribeFilter')}>
        <SubcribeContent
          type={type}
          options={searchParam}
          onSuccess={handleSuccess} 
        />
      </Dialog>
    </>
  )
}

SubcribeTrigger.propTypes = {
  type: PropTypes.string,
  searchParam: PropTypes.object,
}
